/* eslint-disable react/no-danger */
import { useState } from 'react';
import PropTypes from 'prop-types';

import DOMPurify from 'dompurify';
import { FormattedMessage, injectIntl } from 'react-intl';
import _ from 'lodash';
import ChevronRight from '@mui/icons-material/ChevronRight';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { getPreferenceTz } from 'utils/timezone';
import { normalizeNoteSpaces } from 'utils/noteHtml';
import NoteHeartIcon from './partials/note-heart.svg';

const styles = {
  container: {
    width: '100%',
    marginTop: '10px',
    marginBottom: '10px',
    border: '1px solid #d0d9de',
    textAlign: 'left',
    backgroundColor: 'white',
    borderRadius: '12px',
    minHeight: '62px',
    padding: '16px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
};

function PreviousNotes({ allAppointmentNotes = [], intl }) {
  const [showPreviousNotes, setShowPreviousNotes] = useState(false);

  const renderAllAppointmentNotes = notes =>
    _.map(notes, ({ id, start_date: startDate, note }) => (
      <div key={id}>
        <h1 className="previousNotesTitle">
          {intl.formatDate(startDate, {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: getPreferenceTz(),
          })}
        </h1>
        <div
          className="noteText"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(normalizeNoteSpaces(note)),
          }}
        />
      </div>
    ));

  return (
    <div
      style={styles.container}
      role="button"
      tabIndex={0}
      onClick={() => setShowPreviousNotes(prev => !prev)}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setShowPreviousNotes(prev => !prev);
        }
      }}
      aria-pressed={showPreviousNotes}
    >
      <div style={styles.titleContainer}>
        <NoteHeartIcon />
        <span
          style={{
            fontSize: '16px',
            fontWeight: 600,
          }}
        >
          <FormattedMessage defaultMessage="Previous Notes" />
        </span>
        {showPreviousNotes ? (
          <KeyboardArrowDown style={{ opacity: '.5', marginLeft: 'auto' }} />
        ) : (
          <ChevronRight style={{ opacity: '.5', marginLeft: 'auto' }} />
        )}
      </div>
      <div>
        {showPreviousNotes && (
          <div style={{ paddingTop: '32px', overflow: 'auto', height: 455 }}>
            {allAppointmentNotes.length > 0
              ? renderAllAppointmentNotes(allAppointmentNotes)
              : ''}
          </div>
        )}
      </div>
    </div>
  );
}

PreviousNotes.propTypes = {
  allAppointmentNotes: PropTypes.array,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(PreviousNotes);
